import classNames from 'classnames';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import Checkbox from 'components/Checkbox';
import { intlGet } from 'utils/intlGet';
import { ConfirmationProps } from './models';
import styles from './styles.module.scss';

const Confirmation: React.FunctionComponent<ConfirmationProps> = (props) => {
  const { hideModal, modalWindowId, options } = props;
  const [doNotAskAgain, setDoNotAskAgain] = useState<boolean>(false);

  const handleAccept = (): void => {
    hideModal(modalWindowId, { accepted: true, doNotAskAgain });
  };

  const handleDecline = (): void => {
    hideModal(modalWindowId, { accepted: false, doNotAskAgain });
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setDoNotAskAgain(event.target.checked);
  };

  const title = options.get('title');
  const message = options.get('message');
  const messageLinks = options.get('messageLinks');
  const acceptLabel = options.get('acceptLabel');
  const declineLabel = options.get('declineLabel');
  const showDoNotAskAgain = options.get('showDoNotAskAgain', false);
  const className = options.get('className');

  const renderMessageWithLinks = (): React.ReactNode => {
    if (!messageLinks || messageLinks.size === 0) {
      return message;
    }

    const parts: React.ReactNode[] = [];
    let remaining = message;

    messageLinks.entrySeq().forEach(([linkText, url]: [string, string]) => {
      const index = remaining.indexOf(linkText);
      if (index === -1) {
        return;
      }
      parts.push(remaining.slice(0, index));
      parts.push(
        <a key={linkText} href={url} target="_blank" rel="noopener noreferrer">
          {linkText}
        </a>,
      );
      remaining = remaining.slice(index + linkText.length);
    });

    parts.push(remaining);

    return parts;
  };

  return (
    <div className={classNames(styles.Confirmation, className && styles[className])}>
      <header>{title}</header>
      <section>{renderMessageWithLinks()}</section>
      <footer>
        {showDoNotAskAgain && (
          <div className={styles.checkboxContainer}>
            <Checkbox
              checked={doNotAskAgain}
              onChange={handleCheckboxChange}
              label={intlGet('AITranslation', 'DoNotAskAgain')}
              name="doNotAskAgain"
              dataTestId="confirmation-do-not-ask-again"
            />
          </div>
        )}
        <div className={styles.buttonsContainer}>
          <Button onClick={handleDecline} variant="secondary">{declineLabel}</Button>
          <Button onClick={handleAccept} variant="primary">{acceptLabel}</Button>
        </div>
      </footer>
    </div>
  );
};

export default Confirmation;
